import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip, Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const KPITemplate = () => {

  const [mode, setMode] = useState("INITIAL");

  // const [isEditable, setIsEditable] = useState(false);
  // const [enableEntry, setEnableEntry] = useState(false);
  // const [editMode, setEditMode] = useState(false);

  const isHeaderEnabled = (mode === "NEW" || mode === "EDIT");
  const isDetailsEnabled = (mode === "PROCEED" || mode === "EDIT");

  const isDropdownEnabled = (mode === "INITIAL");
  const isNewEnabled = (mode === "INITIAL");
  const isEditEnabled = (mode === "INITIAL");
  const isProceedEnabled = (mode === "NEW");
  const isSaveEnabled = (mode === "PROCEED" || mode === "EDIT");
  const isClearEnabled = (mode === "NEW");

  const [ddlKpis, setDdlKpis] = useState([]);
  const [errors, setErrors] = useState({});
  const [kpiTemplIdForEdits, setKpiTemplIdForEdits] = useState([]);
  const [kpiTemplIdForEdit, setKpiTemplIdForEdit] = useState(""); 

  const [genMasters, setGenMasters] = useState([]);

  const [headerData, setHeaderData] = useState({
    template_irn: "",
    template_name: "",
    applicable: "",
    active: "Y"
  });

  const [childRows, setChildRows] = useState([
    {
      kpi_id: "",
      kpi_max_marks: '',
      // weight: "",
      // target_override: ""
    }
  ]);

  useEffect(() => {

    fetchKPITemplate();

  }, []);

  const fetchKPITemplate = async () => {

    try {

      setKpiTemplIdForEdits([]);
      const res = await axios.get(`${BASE_URL}/api/ddl_KPI_Template`);
      setKpiTemplIdForEdits(res.data || []);

      const response = await axios.get(`${BASE_URL}/api/ddl_Gen_Mst_Type`,
        { params: { type: 'CATG' } });

      if (response.data && response.data.length > 0) {
        setGenMasters(response.data);
      }

    } catch (err) {
      console.error("Error loading KPI list", err);
    }

  };

  const handleHeaderChange = (e) => {

    setErrors({});
    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));

  };

  const handleChildChange = (index, e) => {

    const { name, value } = e.target;
    const updated = [...childRows];

    updated[index][name] = value;

    setChildRows(updated);

    setErrors(prev => ({ ...prev, rowErrors: { ...prev.rowErrors, [index]: { ...prev.rowErrors?.[index], [name]: false } } }));

  };

  const addRow = () => {

    setChildRows([...childRows, { kpi_id: "" }]);

  };

  const removeRow = (index) => {
    const updated = [...childRows];
    updated.splice(index, 1);
    setChildRows(updated);
  };

  const handleNew = () => {
    setMode("NEW");
    //setIsEditable(true);
    setHeaderData({
      template_name: "",
      applicable: "",
      active: "Y"
    });
    setChildRows([{ kpi_id: "", 
    //  weight: "", target_override: ""
     }]);
  };

  const handleProceed = async () => {

    if (!headerData.template_name || headerData.template_name === '') {
      //toast.error("Please enter Template Name",  {autoClose: 2000, position: "top-center", autoClose: false});
      setErrors({ template_name: true });
      toast.error("Please enter Template Name", {pauseOnHover: true});
      // ToastMessage.snakebarMessage(
      //   "Validation",
      //   "Please enter Template Name",
      //   false
      // );
      return;
    }

    if (headerData.applicable === '') {
      setErrors({ applicable: true });
      toast.error("Please Select Applicable.");
      //alert('Please Select Applicable.');
      return;
    }

    setDdlKpis([]);

    const res = await axios.get(`${BASE_URL}/api/ddl_KPI_Masters`, { params: { p_Applicable: headerData.applicable } });

    setDdlKpis(res.data || []);

    // setEnableEntry(true);
    setMode("PROCEED");

  }

  const handleSave = async () => {


    for (let i = 0; i < childRows.length; i++) {
      if (!childRows[i].kpi_id) {
        setErrors({ rowErrors: {[i]: { kpi_id: true }}});
        toast.error(`Please select KPI at Row # ${i + 1}`);
        return;
      }
    }

    const uniqueKpis = new Set();

    for (let i = 0; i < childRows.length; i++) {

      if (uniqueKpis.has(childRows[i].kpi_id)) {
        setErrors({ rowErrors: { [i]: { kpi_id: true } } });
        toast.error(`Duplicate KPI at row ${i + 1}`);
        return;
      }

      uniqueKpis.add(childRows[i].kpi_id);

    }

    const isConfirmed = window.confirm("Save KPI Template ?");
    if (!isConfirmed) return;

    const payload = {
      header: headerData,
      details: childRows
    };

    try {

      const response = await axios.post(`${BASE_URL}/api/save_KPI_Template`, payload);

      if (response.data.message === '1') {
        toast.success(`KPI Template saved successfully`);
        fetchKPITemplate();
        resetPage();
      } else {
        toast.error(`Error saving KPI`);
      }

    } catch (err) {
      console.error(err);
      toast.error("Error saving template");
    }
  };

  const handleClear = () => {
    if (window.confirm("Clear data?")) {
      resetPage();
    }
  };

  const resetPage = () => {

      setHeaderData({
        template_name: "",
        applicable: "",
        active: "Y"
      });
      setChildRows([{ kpi_id: "", 
        weight: "", target_override: "" 
      }]);

      // setIsEditable(false);
      // setEnableEntry(false);
      setMode("INITIAL");
      setDdlKpis([]);
      setErrors({});

   }

  const handleEdit = async () => {

    if (!kpiTemplIdForEdit || kpiTemplIdForEdit === '') {
      toast.error("Please Select KPI Template for Edit.");
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/get_KPI_Template_ById`, { params: { p_Template_Id: kpiTemplIdForEdit } });

    if (response.data && response.data.length > 0) {
      // setIsEditable(true);
      // setEditMode(true);
      // setEnableEntry(true);
      setMode("EDIT");
      headerData.applicable = response.data[0].applicable;
      headerData.template_irn = response.data[0].template_irn;
      headerData.template_name = response.data[0].template_name;
      headerData.active = response.data[0].active;
      const res = await axios.get(`${BASE_URL}/api/ddl_KPI_Masters`, { params: { p_Applicable: response.data[0].applicable } });
      setDdlKpis(res.data || []);
      setChildRows(response.data);
    } else {
      toast.error("No Template Data to retrieve, please change Search Filter !");
    }

  };

  const options = kpiTemplIdForEdits.map(code => ({
    value: code.templ_id,
    label: code.templ_name
  }));

  return (

    <Container fluid className="p-3">

      {/* HEADER */}

      <Card className="mb-3 p-3">

        <Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}>
                Template Name
              </InputGroup.Text>
              <input
                //className="form-control"
                className={`form-control ${errors.template_name ? "is-invalid" : ""}`}
                name="template_name"
                value={headerData.template_name}
                disabled={!isHeaderEnabled}
                onChange={handleHeaderChange}
              />
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>
                Applicable
              </InputGroup.Text>
              <select
                //className="form-select"
                className={`form-select ${errors.applicable ? "is-invalid" : ""}`}
                name="applicable"
                value={headerData.applicable}
                disabled={!isHeaderEnabled}
                onChange={handleHeaderChange}
              >
                <option value="">--Select Category--</option>
                {genMasters.map(gm => (
                      <option key={gm.gen_id} value={gm.gen_id}>{gm.gen_desc}</option>
                ))}
                {/* <option value="T">Teaching Staff</option>
                <option value="A">Admin Staff</option>
                <option value="G">Grade-IV Staff</option> */}
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <InputGroup>
              <InputGroup.Text>Active</InputGroup.Text>
              <select
                className="form-select"
                name="active"
                value={headerData.active}
                disabled={!isHeaderEnabled}
                onChange={handleHeaderChange}
              >
                <option value="Y">Yes</option>
                <option value="N">No</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={2}>
            <Button
              variant="primary"
             // disabled={!isHeaderEnabled || editMode}
              disabled={!isProceedEnabled}
              onClick={handleProceed}
            >
              Proceed KPI
            </Button>
          </Col>

        </Row>

        {/* Buttons */}

        {/* <div className="d-flex justify-content-end gap-2 flex-wrap"> */}
        <Row className="mt-1">

          <Col md={12}>

            <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">

              <div style={{ width: "500px", flexShrink: 0 }}>
                  <Select name="kpiTemplIdForEdit" options={options}
                    value={options.find(option => option.value === kpiTemplIdForEdit)}
                    onChange={selectedOption => setKpiTemplIdForEdit(selectedOption.value)}
                    //isDisabled={isEditable}
                    isDisabled={!isDropdownEnabled}
                    placeholder="-- Select KPI Template For Edit --"
                  />
                
              </div>

              <Button
                style={{ width: "130px" }}
                variant="primary"
                onClick={handleNew}
                //disabled={isEditable}
                disabled={!isNewEnabled}
              >
                New
              </Button>

              <Button
                style={{ width: "130px" }}
                variant="secondary"
                //disabled={!isEditable}
               // disabled={!isClearEnabled}
                onClick={handleClear}
              >
                Clear
              </Button>
              
              <Button
                style={{ width: "130px" }}
                variant="primary"
                onClick={handleEdit}
                //disabled={isEditable}
                disabled={!isEditEnabled}
              >
                Edit
              </Button>

              <Button
                style={{ width: "130px" }}
                variant="success"
                onClick={handleSave}
                //disabled={!isDetailsEnabled}
                disabled={!isSaveEnabled}
              >
                Save
              </Button>

            </div>
          </Col>
        </Row>

      </Card>

      {/* CHILD TABLE */}

      <Card className="p-3">

        <div style={{ minHeight: '220px' }} className="table-wrapper">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

            <thead>
              <tr>
                <th style={{ width: "5%", textAlign: "center" }}>#</th>
                <th style={{ width: "70%" }}>KPI</th>
                <th style={{ width: "15%", textAlign: "right" }}>Max Score</th>
                <th style={{ width: "10%" }}></th>
              </tr>
            </thead>

            <tbody>

              {childRows.map((row, index) => (

                <tr key={index}>

                  <td style={{ textAlign: "center" }}>{index + 1}</td>

                  <td>
                    <Select name="kpi_id"
                      options={ddlKpis.map(kpi => ({
                        value: kpi.kpi_irn,
                        label: kpi.kpi_name
                      }))}
                      value={ddlKpis
                        .map(kpi => ({ value: kpi.kpi_irn, label: kpi.kpi_name }))
                        .find(option => String(option.value) === String(row.kpi_id)) || null}
                      onChange={(selectedOption) =>
                        handleChildChange(index, {
                          target: {
                            name: "kpi_id",
                            value: selectedOption ? selectedOption.value : ""
                          }
                        })
                      }
                      isDisabled={!isDetailsEnabled}
                      placeholder="--Select KPI--"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />
                  </td>
{/*
                  <td>
                    <select
                      className={`form-select ${errors.rowErrors?.[index]?.kpi_id ? "is-invalid" : ""}`}
                      name="kpi_id"
                      value={row.kpi_id}
                      disabled= {!isDetailsEnabled}
                      onChange={(e) => handleChildChange(index, e)}
                    >
                      <option value="">--Select KPI--</option>
                      {ddlKpis.map(kpi => (
                        <option key={kpi.kpi_irn} value={kpi.kpi_irn}>
                          {kpi.kpi_name}
                        </option>
                      ))}
                    </select>
                  </td>
*/}
                  <td >
                    <input type="number" className="form-control" name="kpi_max_marks"
                      value={row.kpi_max_marks || ''} disabled={!isDetailsEnabled} style={{ textAlign: "right" }}
                      onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  
                  <td style={{ textAlign: "center" }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" size="sm" onClick={() => removeRow(index)} >
                        Delete
                      </Button>
                    )}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}
          >
            <Button
              variant="primary"
              onClick={addRow}
              disabled={!isDetailsEnabled}
              style={{
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                padding: "0",
                fontSize: "30px"
              }}
            >
            +
          </Button>
          </OverlayTrigger>
        </div>

      </Card>

    </Container>
  );
};

export default KPITemplate;
